import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ArrowLeft, MailCheck, KeyRound } from "lucide-react";
import { toast } from "sonner";
import logoLight from "@/assets/logo-light.png";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [codigo, setCodigo] = useState("");
  const [senha, setSenha] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [loading, setLoading] = useState(false);

  const sendCode = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      toast.success(data.message); setStep(2);
    } catch (err) { toast.error(err.response?.data?.detail || "Não foi possível enviar o código"); }
    finally { setLoading(false); }
  };
  const reset = async (e) => {
    e.preventDefault();
    if (senha !== confirmar) return toast.error("As senhas não coincidem");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { email, codigo, nova_senha: senha });
      toast.success("Senha redefinida! Faça login com a nova senha."); navigate("/login");
    } catch (err) { toast.error(err.response?.data?.detail || "Erro ao redefinir"); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-white" data-testid="forgot-page">
      <div className="w-full max-w-sm fade-up">
        <img src={logoLight} alt="TRT" className="h-14 w-auto mb-6" />
        <h2 className="text-2xl font-bold tracking-tight flex items-center gap-2"><KeyRound className="w-5 h-5 gold-text" /> Recuperar senha</h2>
        {step === 1 ? (
          <form onSubmit={sendCode} className="space-y-4 mt-4">
            <p className="text-slate-500 text-sm">Informe o e-mail da sua conta. Enviaremos um código de 6 dígitos.</p>
            <div><Label>E-mail</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" data-testid="forgot-email" /></div>
            <Button type="submit" disabled={loading} className="w-full bg-onyx hover:bg-black text-white h-11 font-semibold" data-testid="forgot-send">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar código"}</Button>
          </form>
        ) : (
          <form onSubmit={reset} className="space-y-4 mt-4">
            <div className="flex items-center gap-2 text-emerald-700 bg-emerald-50 rounded-lg px-3 py-2 text-sm"><MailCheck className="w-4 h-4" /> Código enviado para <b className="truncate">{email}</b></div>
            <div><Label>Código (6 dígitos)</Label><Input inputMode="numeric" maxLength={6} required value={codigo} onChange={(e) => setCodigo(e.target.value.replace(/\D/g, ""))} className="mt-1.5 tracking-[0.5em] text-center text-lg mono" data-testid="forgot-code" /></div>
            <div><Label>Nova senha (mín. 8)</Label><Input type="password" required minLength={8} value={senha} onChange={(e) => setSenha(e.target.value)} className="mt-1.5" data-testid="forgot-new" /></div>
            <div><Label>Confirmar nova senha</Label><Input type="password" required value={confirmar} onChange={(e) => setConfirmar(e.target.value)} className="mt-1.5" data-testid="forgot-confirm" /></div>
            <Button type="submit" disabled={loading || codigo.length !== 6} className="w-full bg-gold hover:bg-[hsl(var(--gold-hover))] text-black h-11 font-semibold" data-testid="forgot-reset">{loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Redefinir senha"}</Button>
            <button type="button" onClick={() => setStep(1)} className="text-xs text-slate-500 w-full text-center">Não recebeu? Enviar novamente</button>
          </form>
        )}
        <Link to="/login" className="mt-6 flex items-center justify-center gap-1 text-sm text-slate-500 hover:text-slate-800" data-testid="forgot-back"><ArrowLeft className="w-4 h-4" /> Voltar ao login</Link>
      </div>
    </div>
  );
}
